import Vue from 'vue';
import Router from 'vue-router';
//import Login from '@/views/login/login';
const BottomBar = r => require.ensure([], () => r(require('@/views/bottomBar/bottomBar1')),'home');
const Home = r => require.ensure([], () => r(require('@/views/home/home')),'home');

const Machine = r => require.ensure([], () => r(require('@/views/machine/machine')),'machine');
const AllMachine = r => require.ensure([], () => r(require('@/views/machine/allMachine')),'machine');
const NostockMachine = r => require.ensure([], () => r(require('@/views/machine/nostockMachine')),'machine');
const FaultMachine = r => require.ensure([], () => r(require('@/views/machine/faultMachine')),'machine');
const OutlineMachine = r => require.ensure([], () => r(require('@/views/machine/outlineMachine')),'machine');
const MachineStatus = r => require.ensure([], () => r(require('@/views/machine/machineStatus')),'machine');
const MacCircuit = r => require.ensure([], () => r(require('@/views/machine/macCircuit')),'machine');

const MacDetail = r => require.ensure([], () => r(require('@/views/machine/macDetail')),'machineDetail');
const FaultMacDetail = r => require.ensure([], () => r(require('@/views/machine/faultMacDetail')),'machineDetail');

const CtrlMac = r => require.ensure([], () => r(require('@/views/machineCtrl/ctrlMac')),'ctrlMac');
const ReplenishmentRecord = r => require.ensure([], () => r(require('@/views/machineCtrl/replenishmentRecord')),'replenishmentRecord');
const GoodsTops = r => require.ensure([], () => r(require('@/views/machineCtrl/goodsTops')),'GoodsTops');

const Operate = r => require.ensure([], () => r(require('@/views/operate/operate')),'operate');
const OrderForm = r => require.ensure([], () => r(require('@/views/operate/orderForm')),'operate');
const Refund = r => require.ensure([], () => r(require('@/views/operate/refund')),'refund');
const MacOrderForm = r => require.ensure([], () => r(require('@/views/operate/macOrderForm')),'operate');
const PayWay = r => require.ensure([], () => r(require('@/views/operate/payWay')),'operate');
const Tops = r => require.ensure([], () => r(require('@/views/operate/tops')),'operate');
const shopStockoutRate = r => require.ensure([], () => r(require('@/views/operate/shopStockoutRate')),'shopStockoutRate');
const deviceStockoutRate = r => require.ensure([], () => r(require('@/views/operate/deviceStockoutRate')),'deviceStockoutRate');

const User = r => require.ensure([], () => r(require('@/views/user/user')),'user');
const Login = r => require.ensure([], () => r(require('@/views/user/login')),'user');
const About = r => require.ensure([], () => r(require('@/views/user/aboutus')),'user');
const EditPwd = r => require.ensure([], () => r(require('@/views/user/editPwd')),'user');

const NostockDetail = r => require.ensure([], () => r(require('@/views/stock/NostockDetail')),'stock');
const Replenishment = r => require.ensure([], () => r(require('@/views/stock/replenishment')),'stock');
const OpReplenishment = r => require.ensure([], () => r(require('@/views/stock/op_replenishment')),'stock');
const OpGoodsList = r => require.ensure([], () => r(require('@/views/stock/op_goodsList')),'stock');
const OpSuccess = r => require.ensure([], () => r(require('@/views/stock/op_success')),'stock');
const Stocking = r => require.ensure([], () => r(require('@/views/stock/stocking')),'stock');

const ConfirmSuc = r => require.ensure([], () => r(require('@/views/tips/confirm_suc')),'tips');
const ReviseSuc = r => require.ensure([], () => r(require('@/views/tips/revise_suc')),'tips');

const GoodsList = r => require.ensure([], () => r(require('@/views/theGoods/goodsList')),'theGoods');
const SetupGoods = r => require.ensure([], () => r(require('@/views/theGoods/setupGoods')),'theGoods');
const GoodsSearch = r => require.ensure([], () => r(require('@/views/search/goodsSearch')),'theGoods');
const ChannelTest = r => require.ensure([], () => r(require('@/views/theGoods/channelTest')),'channelTest');

const RefundApply = r => require.ensure([], () => r(require('@/views/wxlink/refundApply')),'refundApply');

const Test = r => require.ensure([], () => r(require('@/views/operate/test')),'test');


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
    	path: '/',
    	redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/bottomBar', component: BottomBar,
        children: [
            { path: '',redirect:'home/home'},
            { name: 'home', path: 'home/:id',component: Home },
            { 
                path: 'machine/:id',component: Machine,
                children: [
                    { path: '',redirect: 'allMachine' },
                    { path: 'allMachine',component: AllMachine},
                    { path: 'nostockMachine',component: NostockMachine },
                    { path: 'faultMachine',component: FaultMachine },
                    { path: 'outlineMachine',component: OutlineMachine },
                ]
            },
            { name: 'operate', path: 'operate/:id/:date/:stat',component: Operate },
            { name: 'user', path: 'user/:id',component: User }
            
        ]
    },
    /* operate */
    { path: '/orderForm/:stat/:date',component: OrderForm },
    { path: '/refund/:orderId',component: Refund },
    { path: '/macOrderForm/:machineId',component: MacOrderForm },
    { path: '/payWay/:dataStat/:date',component: PayWay },
    { path: '/tops/:stat/:date',component: Tops },
    { path: '/shopStockoutRate', component: shopStockoutRate },
    { path: '/deviceStockoutRate/:shopId', component: deviceStockoutRate },

    /* machine detail */
    { path: '/machine/macDetail/:id',component: MacDetail },
    { path: '/machine/faultMacDetail/:id',component: FaultMacDetail },
    { path: '/machineStatus/:id', component: MachineStatus },
    { path: '/machine/macCircuit', component: MacCircuit },
    /* machine ctrl */
    { path: '/machineCtrl/ctrlMac/:id',component: CtrlMac },
    { path: '/machineCtrl/replenishmentRecord',component: ReplenishmentRecord },
    { path: '/machineCtrl/GoodsTops',component: GoodsTops },
    /* stock */
    { path: '/nostockDetail/:id/:name/:code',component: NostockDetail },
    { path: '/replenishment/:machineCode',component: Replenishment }, 
    { path: '/op_replenishment/:machineCode/:latitude/:longitude',component: OpReplenishment },
    //{ path: '/op_goodsList/:doorCode',component: OpGoodsList },
    //{ path: '/op_success/:machineCode',component: OpSuccess },
    { path: '/replenishment/:machineCode/:latitude/:longitude',component: Replenishment },
    { path: '/stocking',component: Stocking},
    /* theGoods */
    { path: '/goodsList',component: GoodsList },
    { path: '/setupGoods',component: SetupGoods },
    { path: '/channelTest/:id', component: ChannelTest },
    /* goodsSearch */
    { path: '/goodsSearch',component: GoodsSearch },
    /* user */
    { path: '/about',component: About },
    { path: '/editPwd/:loginName',component: EditPwd },
    /* tips */
    { path: '/confirm_suc',component: ConfirmSuc },
    { path: '/revise_suc',component: ReviseSuc },
    /* wxlink */
    { path: '/wxlink/refundApply/:orderId',component: RefundApply },
    /* test */
    { path: '/test',component: Test }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js